export enum RoleTypes {
  ADMIN = 0,
  COORDINATOR = 1,
  EXPERT = 2,
  PARTNER = 3,
  VERIFIER = 4,
}
